/**
 * 6件（per_page）ずつ記事をajaxで読み込む
 * liのクラスにカスタムタクソノミー「book_tag」のIDを付与している（投稿テンプレートのデフォルトに合わせる形）
 */

/** プリフェッチがまだの場合にプリフェッチする */
import prefetchData from '../../../../../../src/assets/scripts/prefetch-rest-api.js';
/** アンカーへのスムーススクロール位置を合わせるために呼び出す */
import { fnc_scrollToHashOnLoad } from '../../../../../../src/assets/scripts/gsap-smoothScroll';

/** @type {number} 初期のページ番号 */
let page = 1;

/** @type {number} 1ページあたりの投稿数 */
const per_page = 6;

/** @type {string} カスタム投稿タイプ */
const post_type = 'book';

/** @type {string|null} URLのパラメータから取得した現在選択されているタグ
 * URLのパラメータからタグを取得　例：/special/?book_tag=115 -> 115
 */
let currentTag = new URLSearchParams(window.location.search).get(
  'book_tag'
);

/** @type {HTMLElement} 投稿リストの要素 */
const postList = document.getElementById('js-book-postlist');

/**
 * loadPosts関数を呼び出すリスナーを定義します。
 */
function loadMorePosts() {
  loadPostsAfterDelay(0, false);
}

/**
 * clickイベントを無効にするリスナーを定義します。
 *
 * @param {Event} event - イベントオブジェクト
 */
function preventClick(event) {
  event.preventDefault();
}

/**
 * 投稿を読み込みます。初期の投稿を読み込む場合はプレースホルダーを置き換え、
 * 「もっと見る」ボタンがクリックされたときは新たに投稿を読み込みます。
 *
 * @param {boolean} [replacePlaceholder=false] - プレースホルダーを置き換えるかどうか。
 */
/* async function loadPosts(replacePlaceholder = false) {
  try {
    let url = `/wp-json/wp/v2/${post_type}?page=${page}&per_page=${per_page}`;
    if (currentTag && currentTag !== 'all') {
      // 'all'が選択されているときはタグを指定しない
      url += `&book_tag=${currentTag}`;
      //console.log(url)
    }

    //postListの兄弟要素の子要素の.js-load-moreを取得
    const loadMoreButton =
      postList.nextElementSibling.querySelector('.js-load-more');

    loadMoreButton.removeEventListener('click', loadMorePosts); // リスナーを削除
    loadMoreButton.removeEventListener('click', preventClick); // リスナーを削除
    loadMoreButton.addEventListener('click', loadMorePosts); // リスナーを再設定

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const posts = await response.json();

    // ページの総数を取得
    const totalPages = parseInt(
      response.headers.get('X-WP-TotalPages'),
      10
    );

    if (totalPages <= page) {
      // 現在のページが総ページ数以下の場合、もしくは記事の総数が6件以下の場合
      loadMoreButton.classList.add('is-no-load'); // クラスを追加
      loadMoreButton.removeEventListener('click', loadMorePosts); // リスナーを削除
      loadMoreButton.addEventListener('click', preventClick); // clickイベントを無効にするリスナーを設定
      loadMoreButton.style.display = 'none'; // ボタンを非表示にする
    } else {
      loadMoreButton.classList.remove('is-no-load'); // クラスを削除
      loadMoreButton.style.opacity = '1'; // ボタンを表示
      loadMoreButton.style.display = 'block'; // cssで透明にしているボタンを表示させる
    }

    // 既存のul要素を取得
    let postListUl = postList.querySelector('ul');
    // 既存のul要素がない場合のみ新しいul要素を作成
    if (!postListUl) {
      postListUl = document.createElement('ul');
      postListUl.className =
        'columns-2 is-style-alternating wp-block-post-template is-layout-grid wp-container-core-post-template-layout-1 wp-block-post-template-is-layout-grid';
      postList.appendChild(postListUl);
    }

    // 記事のデータを元にプレースホルダーを差し替え
    // 新しい投稿をDOMに追加する処理が完了するまで待つ
    const newPosts = await Promise.all(
      posts.map(async (post, index) => {
        // 新しい投稿をDOMに追加する処理
        let newPost;

        //replacePlaceholderがfalseのとき
        if (!replacePlaceholder) {
          newPost = createNewPostElement(post);
          postListUl.appendChild(newPost);
          //console.log('新しい記事をロードしました')
        }

        return newPost;
      })
    );

    if (posts.length > 0) {
      page++; // 投稿がある場合のみページ番号をインクリメント
    }

    if (window.wpGlobalLenis) {
      //Lenisのスクロール可能領域を更新
      window.wpGlobalLenis.resize();
    }

    return newPosts;
  } catch (error) {
    console.error('読み込み中にエラーが発生しました:', error);
  }
} */
function loadPosts(replacePlaceholder = false) {
  let url = `/wp-json/wp/v2/${post_type}?page=${page}&per_page=${per_page}`;
  if (currentTag && currentTag !== 'all') {
    // 'all'が選択されているときはタグを指定しない
    url += `&book_tag=${currentTag}`;
    //console.log(url)
  }

  //postListの兄弟要素の子要素の.js-load-moreを取得
  const loadMoreButton =
    postList.nextElementSibling.querySelector('.js-load-more');

  loadMoreButton.removeEventListener('click', loadMorePosts); // リスナーを削除
  loadMoreButton.removeEventListener('click', preventClick); // リスナーを削除
  loadMoreButton.addEventListener('click', loadMorePosts); // リスナーを再設定

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json().then((posts) => {
        // ページの総数を取得
        const totalPages = parseInt(
          response.headers.get('X-WP-TotalPages'),
          10
        );

        if (totalPages <= page) {
          // 現在のページが総ページ数以下の場合、もしくは記事の総数が6件以下の場合
          loadMoreButton.classList.add('is-no-load'); // クラスを追加
          loadMoreButton.removeEventListener('click', loadMorePosts); // リスナーを削除
          loadMoreButton.addEventListener('click', preventClick); // clickイベントを無効にするリスナーを設定
          loadMoreButton.style.display = 'none'; // ボタンを非表示にする
        } else {
          loadMoreButton.classList.remove('is-no-load'); // クラスを削除
          loadMoreButton.style.opacity = '1'; // ボタンを表示
          loadMoreButton.style.display = 'block'; // cssで透明にしているボタンを表示させる
        }

        // 既存のul要素を取得
        let postListUl = postList.querySelector('ul');
        // 既存のul要素がない場合のみ新しいul要素を作成
        if (!postListUl) {
          postListUl = document.createElement('ul');
          postListUl.className =
            'columns-2 is-style-alternating wp-block-post-template is-layout-grid wp-container-core-post-template-layout-1 wp-block-post-template-is-layout-grid';
          postList.appendChild(postListUl);
        }

        // 記事のデータを元にプレースホルダーを差し替え
        // 新しい投稿をDOMに追加する処理が完了するまで待つ
        const newPosts = posts.map((post, index) => {
          // 新しい投稿をDOMに追加する処理
          let newPost;

          //replacePlaceholderがfalseのとき
          if (!replacePlaceholder) {
            newPost = createNewPostElement(post);
            postListUl.appendChild(newPost);
            //console.log('新しい記事をロードしました')
          }

          return newPost;
        });

        if (posts.length > 0) {
          page++; // 投稿がある場合のみページ番号をインクリメント
        }

        if (window.wpGlobalLenis) {
          //Lenisのスクロール可能領域を更新
          window.wpGlobalLenis.resize();
        }

        return newPosts;
      });
    })
    .catch((error) => {
      console.error('読み込み中にエラーが発生しました:', error);
    });
}
/**
 * 投稿データからHTML文字列を生成します。
 *
 * @param {Object} post - 投稿データオブジェクト。
 * @returns {string} 投稿データから生成されたHTML文字列。
 */
function createPostHtml(post) {
  return `
    <a href="${post.link}">
      <div class="wp-block-cb-book-tax-filter__block">
        <div class="wp-block-cb-book-tax-filter__main">
          <h3 class="wp-block-cb-book-tax-filter__post-title">${post.title.rendered
    }</h3>
          <div class="wp-block-cb-book-tax-filter__summary">
            <h4 class="wp-block-cb-book-tax-filter__book-name">${post.book_name
    }</h4>
            <p class="wp-block-cb-book-tax-filter__book-curator">${post.book_curator.replace(
      /\r\n|\r|\n/g,
      '<br>'
    )}</p>
          </div>
        </div>
        <div class="wp-block-cb-book-tax-filter__post-featured-image">
          ${post.featured_media_url
      ? `<img src="${post.featured_media_url}" alt="${post.title.rendered}">`
      : ''
    }
        </div>
      </div>
    </a>
  `;
}

/**
 * 投稿データから新しい投稿要素を作成します。
 *
 * @param {Object} post - 投稿データ。
 * @returns {HTMLElement} 新しい投稿要素。
 */
function createNewPostElement(post) {
  // li要素を作成
  const postElement = document.createElement('li');
  postElement.className = post.book_tag
    ? post.book_tag.map((id) => `book_tag-${id}`).join(' ')
    : ''; // class属性に接頭辞をつけたタグのIDを設定
  postElement.innerHTML = createPostHtml(post);
  return postElement;
}

/**
 * 指定されたセレクタに対応するプレースホルダーにデータをセットします。
 *
 * @param {string} placeholderSelector - プレースホルダー要素のセレクタ。
 * @param {Object[]} data - 投稿データオブジェクトの配列。
 */
function setPlaceholderData(placeholderSelector, data) {
  const placeholder = document.querySelector(placeholderSelector);
  if (placeholder) {
    data.forEach((post) => {
      // createNewPostElement関数を使用して新しい投稿要素を作成
      const element = createNewPostElement(post);
      // プレースホルダーに新しい要素を追加
      placeholder.appendChild(element);
    });
  }
}

/* async function placeholderContainer(prefetchedDataKey, placeholderSelector) {
  // セッションストレージからプリフェッチしたデータを取得
  let prefetchedData = JSON.parse(
    sessionStorage.getItem(prefetchedDataKey)
  );

  if (prefetchedData) {
    //console.log(`${prefetchedDataKey}が存在します`);
    setPlaceholderData(placeholderSelector, prefetchedData);
  } else {
    //console.log( `${prefetchedDataKey}が存在しません。データをプリフェッチします。`);
    await prefetchData();
    // プリフェッチ後に再度データを取得
    prefetchedData = JSON.parse(
      sessionStorage.getItem(prefetchedDataKey)
    );
    //console.log(prefetchedData);
    if (prefetchedData) {
      setPlaceholderData(placeholderSelector, prefetchedData);
    }
  }
  // アンカーへのスムーススクロール位置を合わせる
  fnc_scrollToHashOnLoad(80);
}
 */
function placeholderContainer(prefetchedDataKey, placeholderSelector) {
  // セッションストレージからプリフェッチしたデータを取得
  let prefetchedData = JSON.parse(
    sessionStorage.getItem(prefetchedDataKey)
  );

  if (prefetchedData) {
    //console.log(`${prefetchedDataKey}が存在します`);
    setPlaceholderData(placeholderSelector, prefetchedData);
  } else {
    //console.log( `${prefetchedDataKey}が存在しません。データをプリフェッチします。`);
    prefetchData().then(() => {
      // プリフェッチ後に再度データを取得
      prefetchedData = JSON.parse(
        sessionStorage.getItem(prefetchedDataKey)
      );
      //console.log(prefetchedData);
      if (prefetchedData) {
        setPlaceholderData(placeholderSelector, prefetchedData);
      }
    });
  }
  // アンカーへのスムーススクロール位置を合わせる
  fnc_scrollToHashOnLoad(80);
}

/**
 * 指定した時間後に投稿を読み込みます。
 *
 * @param {number} delay - 遅延時間（ミリ秒）。
 * @param {boolean} replacePlaceholder - プレースホルダーを置き換えるかどうか。
 */
function loadPostsAfterDelay(delay, replacePlaceholder = false) {
  setTimeout(() => {
    loadPosts(replacePlaceholder);
  }, delay);
}

/**
 * 指定されたタグに基づいて記事をフィルタリングし、表示を更新します。
 * この関数は、ラジオボタンの選択変更時やページロード時に呼び出されます。
 * URLのクエリパラメータから取得したタグや、ラジオボタンから取得したタグに基づいて、
 * 対応する記事のみを表示するために既存の投稿をクリアし、新しい投稿を取得して表示します。
 *
 * @param {string} tag - フィルタリングするためのタグ。このタグに基づいて記事がフィルタリングされます。
 */
/* async function filterPostsByTag(tag) {
  currentTag = tag;
  page = 1; // ページ番号をリセット

  try {
    // 既存の投稿をクリア
    const postListUl = document.querySelector('#js-book-postlist ul');
    while (postListUl.firstChild) {
      postListUl.removeChild(postListUl.firstChild);
    }

    // 新しい投稿を取得して表示
    const newPosts = await loadPosts();
    newPosts.forEach((post) => {
      postListUl.appendChild(post);
    });
  } catch (error) {
    console.error('Error loading posts:', error);
  }
} */
function filterPostsByTag(tag) {
  currentTag = tag;
  page = 1; // ページ番号をリセット

  // 既存の投稿をクリア
  const postListUl = document.querySelector('#js-book-postlist ul');
  while (postListUl.firstChild) {
    postListUl.removeChild(postListUl.firstChild);
  }

  // 新しい投稿を取得し��表示
  loadPosts().then((newPosts) => {
    newPosts.forEach((post) => {
      postListUl.appendChild(post);
    });
  }).catch((error) => {
    console.error('Error loading posts:', error);
  });
}
/**
 * ラジオボタンの選択に応じて記事をフィルタリングします。
 * ラジオボタンが変更されると、選択されたタグ（currentTag）に基づいて記事を再取得します。
 */

const radios = document.querySelectorAll('input[type=radio][name=book_tag]');
radios.forEach(function (radio) {
  radio.addEventListener('change', function () {
    filterPostsByTag(this.value);
  });
});

/**
 * URLのクエリパラメータから`book_tag`を取得し、該当するラジオボタンを選択状態にします。
 * さらに、取得した`book_tag`に基づいて記事をフィルタリングします。
 * この関数は、ページロード時に呼び出され、
 * ユーザーがURLを直接指定してアクセスした場合やブックマークからアクセスした場合に、
 * 期待される記事が表示されるようにします。
 */
function filterPostsFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const bookTagFromUrl = urlParams.get('book_tag');
  if (bookTagFromUrl) {
    radios.forEach(function (radio) {
      if (radio.value === bookTagFromUrl) {
        radio.checked = true;
        // URLから取得したタグに基づいて記事をフィルタリングする
        filterPostsByTag(bookTagFromUrl);
      }
    });
  }
}

/** ========================
 * 実行
 * ========================== */
document.addEventListener(
  'DOMContentLoaded',
  () => {
    //プレースホルダーを作成
    placeholderContainer(
      'prefetchedData_book',
      '#js-book-placeholder'
    );
    // 初期の投稿を読み込む（プレースホルダーを置き換え）
    loadPostsAfterDelay(0, true);

    // パラメーターに含まれているbook_tag=xxxに該当する記事をフィルタリング
    filterPostsFromUrl();
  },
  false
);

window.addEventListener('load', function () {
  if (window.wpGlobalLenis) {
    // Lenisのスクロール可能領域を更新
    setTimeout(() => {
      window.wpGlobalLenis.resize();
      //console.log('Lenisのスクロール可能領域を更新しました');
    }, 2000);
  }
});

/**
 * 関数の実行を遅延させ、高頻度で発生するイベント（例えば、リサイズやスクロール）において、
 * 関数の実行回数を制限するためのデバウンス関数。
 *
 * @param {Function} func - 遅延実行する関数。
 * @param {number} wait - 関数の実行を遅延させる時間（ミリ秒）。
 * @param {boolean} immediate - trueの場合、先頭で即時実行する。
 * @returns {Function} デバウンス処理を適用した関数。
 */
function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
/**
 * .js-book_tag-moreボタンの直前にあるul要素の高さを調整し、
 * 特定の行数に基づいて内容を見切れるように設定する。
 * また、ボタンクリックでulの内容を全て表示し、ボタンを非表示にするイベントを設定する。
 */
document.addEventListener('DOMContentLoaded', function () {
  const adjustUlHeight = function () {
    const moreButton = document.querySelector('.js-book_tag-more');
    if (moreButton) {
      //moreボタンを押下で全部見せる
      moreButton.addEventListener('click', function () {
        const ul = this.previousElementSibling;
        if (ul && ul.tagName === 'UL') {
          // ulの高さ制限を解除
          ul.style.height = 'auto';
          ul.style.overflow = 'visible';
        }
        // moreボタンを非表示にする
        this.style.display = 'none';
      });

      //行数制限して見せる
      const ul = moreButton.previousElementSibling;
      if (ul && ul.tagName === 'UL') {
        const lis = ul.querySelectorAll('li');
        if (lis.length > 0) {
          const liHeight = lis[0].offsetHeight;
          // 画面幅に応じてgapと行数を変更
          const isSP = window.innerWidth <= 768;
          const gap = isSP ? 10 : 16; // SPではgapを8px、それ以外では16px
          const rows = isSP ? 7 : 3; // 768px以下であれば7行、それ以外は3行
          // 各行の高さとgapを考慮した合計高さを計算
          const totalHeight = (liHeight + gap) * rows - gap;
          ul.style.height = `${totalHeight}px`;
          ul.style.overflow = 'hidden';
        }
      }
    }
  };

  // 初期の高さ調整
  adjustUlHeight();

  // リサイズイベントに対応
  window.addEventListener('resize', debounce(adjustUlHeight, 250));
});
